module.exports = __webpack_public_path__ + "static/media/ai_disclaimer.65a3a241.svg";